import script from "./PersonalInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./PersonalInfo.vue?vue&type=script&setup=true&lang=js"

import "./PersonalInfo.vue?vue&type=style&index=0&id=2c8c093d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c8c093d"]])

export default __exports__